<template>
  <div class="myApplication-list">
    <gtable-crud
      ref="gtable-crud"
      :data="data"
      :option="option"
      :page="page"
      :loading="loading"
      @searchChange="searchChange"
      @searchReset="searchReset"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
      @refresh-change="refreshChange"
    >
      <template slot="headMenuLeft">
        <my-tooltip :tooltip="$t('_components.btns.audit')">
          <b-button
            variant="primary"
            class="btn ml-0-5 mr-0-5"
            size="sm"
            @click="handleStepChange()"
          >
            <feather-icon
              icon="EditIcon"
              class="primary cursor-pointer"
              size="20"
            />
          </b-button>
        </my-tooltip>
      </template>
      <template slot="menuLeft" slot-scope="{ row }">
        <my-tooltip :tooltip="$t('_components.btns.audit')">
          <feather-icon
            icon="EditIcon"
            class="text-primary cursor-pointer"
            size="20"
            @click="handleStepChange(row)"
          />
        </my-tooltip>
      </template>
    </gtable-crud>
    <!-- 提交面试结果或者View页面 -->
    <c-modal
      :visible="modalShow"
      :title="i18n('audit')"
      body-class="process-modal"
      size="xl"
      @close="modalShow = false"
      @modelConfirm="auditConfirm"
    >
      <template slot="content">
        <component
          ref="formRef"
          :is="getComponentByOption"
          v-if="modalShow"
          v-bind="componentParams"
        />
      </template>
    </c-modal>
    <b-modal v-model="confirmModalShow" :title="i18n('audit')" centered>
      <div style="background: #faebd6;">
        <my-form
          ref="overFormRef"
          :data="auditForm"
          :loading="auditLoading"
          :option="auditOption"
          :footer-visible="false"
          width="auto"
        />
      </div>
      <template #modal-footer>
        <b-button
          :disabled="auditLoading"
          variant="outline-primary"
          size="sm"
          @click="confirmModalShow = false"
        >
          {{ $t('_components.btns.cancel') }}
        </b-button>
        <b-button
          :disabled="auditLoading"
          variant="primary"
          size="sm"
          @click="handleModelConfirm"
        >
          {{ $t('_components.btns.confirm') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import todoAPi from '@/api/todo/index'
import CDrawer from '@/components/drawer.vue'
import viewPage from '@/views/apply/components/viewPage.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import MyTooltip from '@/components/myTooltip.vue'
import CModal from '@/components/crud/modal.vue'
import MyForm from '@/components/myForm/index.vue'
import components from '@/config/processOption'
import { deepClone } from '@/util/util'
export default {
  components: {
    BButton,
    CDrawer,
    viewPage,
    MyTooltip,
    CModal,
    MyForm,
    ...components,
  },
  data() {
    return {
      query: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      data: [],
      loading: false,

      auditLoading: false,
      rowData: {},
      modalShow: false,
      getComponentByOption: '',
      componentParams: {},
      auditForm: {},
      formId: '',
      processId: '',
      stepMethodKey: '',
      taskType: [],
      confirmModalShow: false,
      multipleAudit: false,
      selectionData: [],
    }
  },
  computed: {
    ...mapGetters(['templateForm']),
    option() {
      const columns = [
        {
          label: this.i18n('processName'),
          field: 'processDefinitionName',
        },
        {
          label: this.i18n('formId'),
          field: 'taskName',
          type: 'select',
          dictData: this.taskType,
          search: true,
          searchBase: true,
        },
        {
          label: this.i18n('createUser'),
          field: 'createUserName',
        },
        {
          label: this.i18n('createTime'),
          field: 'createTime',
          type: 'dateRange',
          search: true,
          searchBase: true,
        },
        {
          label: this.i18n('status'),
          field: 'status',
        },
      ]
      console.log(this.query, this.query)
      const typeItem = this.taskType.filter(
        (item) => item.value == this.query.paramProcessKey,
      )
      console.log(typeItem)
      const selection = typeItem.length > 0 ? typeItem[0].isBatchProcessing : 0
      return {
        header: true, // 显示顶部功能区(默认 true)

        addBtn: false, // 新增按钮(默认 true)
        viewBtn: false, // 显示按钮(默认 true)
        editBtn: false, // 修改按钮(默认 true)
        delBtn: false, // 删除按钮(默认 true)
        // selection: false,
        selection: selection == 1 ? true : false,

        search: true, // 显示搜索(默认 true)
        menu: true, // 显示菜单(默认 true)
        menuWidth: 200, // 默认200
        form: true, // 是否使用自带form (默认true)
        // drawerWidth: 500, // 默认auto
        searchVisible: false, // 搜索默认展开(默认 false)
        fixedHeader: false, // 固定表头(默认 true)
        lineNumbers: false, // 显示每行数据的下标(默认 false)
        searchSpan: 4, // 自定义搜索栅格(默认 4)

        columns,
      }
    },
    auditOption() {
      const columns = [
        {
          label: this.i18n('isPass'),
          field: 'isPass',
          formOption: {
            type: 'radio',
            rules: 'required',
            dictData: [
              {
                label: 'Agree',
                value: true,
              },
              {
                label: 'Reject',
                value: false,
              },
            ],
          },
        },
        {
          label: this.i18n('comment'),
          field: 'comment',
          formOption: {
            type: 'textarea',
            rules:
              typeof this.auditForm.isPass === 'boolean' &&
              !this.auditForm.isPass
                ? 'required'
                : '',
          },
        },
      ]
      const option = {
        columns,
      }
      return option
    },
    templateFormDict() {
      const res = this.templateForm.map((o) => ({
        label: o.formName,
        value: Number(o.id),
      }))
      return res
    },
  },
  mounted() {
    this.onLoad(this.page)
  },
  created() {
    todoAPi.processKeyAndFormName().then((res) => {
      this.taskType = res.data.map((o) => ({
        label: o.formName,
        value: o.processKey,
        isBatchProcessing: o.isBatchProcessing,
      }))
    })
  },
  methods: {
    i18n(param) {
      return this.$t(`_apply.${param}`)
    },
    auditConfirm() {
      if (
        this.$refs.formRef &&
        this.$refs.formRef.data &&
        this.$refs.formRef.data.leaveStartTime
      ) {
        const nowYear = moment().format('YYYY')
        const startYear = moment(this.$refs.formRef.data.leaveStartTime).format(
          'YYYY',
        )
        console.log('startYear', startYear, nowYear)
        if (startYear > nowYear) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text:
                'The leave days falls in the new year and will be automatically approved by the system on the first working day of the new year',
              variant: 'danger',
            },
          })
          return
        }
      }
      const that = this
      console.log(this.getComponentByOption, '表单记录')
      this.auditForm = {
        ispass: true,
        comment: '',
      }
      if (this.getComponentByOption === 'CVEditPage') {
        this.$refs.formRef.$refs.overFormRef.validationForm().then((r) => {
          if (r) {
            that.confirmModalShow = true
          } else {
          }
        })
      } else {
        that.confirmModalShow = true
      }
    },
    async onLoad(page, params = {}) {
      this.loading = true
      const res = await todoAPi.getList(
        page.currentPage,
        page.pageSize,
        Object.assign(params, this.query, this.searchQuery),
      )
      const { data } = res.data
      this.page.total = data.total

      const result = data.records.map((el) => ({
        ...el,
        createUserName: el.variables.createUserName,
      }))
      this.data = result
      this.loading = false
      this.auditForm = {}
    },
    // 搜索按钮被点击
    async searchChange(done, e) {
      const temp = e
      if (temp.createTime) {
        ;[temp.paramStartTime, temp.paramEndTime] = temp.createTime
        delete temp.createTime
      }
      if (temp.taskName) {
        temp.paramProcessKey = temp.taskName
        delete temp.taskName
      }
      this.query = temp
      this.page.currentPage = 1
      await this.onLoad(this.page, temp)
      done()
    },
    // 搜索重置
    searchReset() {
      this.query = {}
      this.onLoad(this.page)
    },
    // 分页更改
    onPageChange(e) {
      console.log(e, 'onPageChange')
    },
    // 当前页改变
    pageChange(e) {
      this.page.currentPage = e
      this.onLoad(this.page)
    },
    // 页数据数量改变
    pageSizeChange(e) {
      this.page.pageSize = e
      this.onLoad(this.page)
    },
    refreshChange() {
      this.onLoad(this.page, this.query)
    },
    handleStepChange(row) {
      if (row) {
        this.multipleAudit = false
        this.rowData = row
        const variables = row.variables || {}
        let option = '{}'
        // '{"component":"CVEditPage","params":[{"key":"processId","value":"processId"}]}'
        if (
          row.taskName === 'Applicant Upload Tickets' &&
          variables.formId == 29
        ) {
          option =
            '{"component":"CVEditPage","params":[{"key":"processId","value":"processId"}]}'
        } else {
          option = variables.option || '{}'
        }
        const parseOption = JSON.parse(option)
        const parmasArr = parseOption.params || []
        const parmas = {}
        parmasArr.forEach((item) => {
          parmas[item.key] = this[item.value] || variables[item.value]
        })
        this.componentParams = parmas
        this.getComponentByOption = parseOption.component
        this.modalShow = true
      } else {
        const selectionData = this.$refs['gtable-crud'].getSelectedRows()
        if (selectionData.length > 0) {
          this.multipleAudit = true
          this.selectionData = selectionData
          this.confirmModalShow = true
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'ERROR',
              icon: 'BellIcon',
              text: this.$t('_components.message.notSelectData'),
              variant: 'danger',
            },
          })
        }
      }
    },
    handleModelConfirm() {
      this.$refs.overFormRef.validationForm().then((r) => {
        console.log(this.getComponentByOption === 'CVEditPage')

        if (r && !this.auditLoading) {
          this.auditLoading = true
          if (this.multipleAudit) {
            const paramsList = []
            this.selectionData.forEach((item) => {
              const params = JSON.parse(JSON.stringify(this.auditForm))
              if (params.isPass) {
                params.flag = 'ok'
              }

              params.taskId = item.taskId
              params.processDefinitionId = item.processDefinitionId
              params.processInstanceId = item.processInstanceId
              params.variables = item.variables
              delete params.isPass
              paramsList.push(params)
            })
            todoAPi
              .completeTaskList(paramsList)
              .then((res) => {
                this.selectionData = []
                this.modalShow = false
                this.auditLoading = false
                this.confirmModalShow = false
                this.onLoad(this.page)
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: this.$t('_default.toast.title'),
                    icon: 'BellIcon',
                    text: this.$t('_default.toast.text.success'),
                    variant: 'success',
                  },
                })
                window.location.reload()
              })
              .catch(() => {
                this.auditLoading = false
              })
          } else {
            const formRefMap = deepClone(this.$refs.formRef.data || {})
            const rowData = deepClone(this.rowData.variables)
            const newMap = Object.assign(rowData, formRefMap)
            const params = JSON.parse(JSON.stringify(this.auditForm))
            if (params.isPass) {
              params.flag = 'ok'
            }

            params.taskId = this.rowData.taskId
            params.processDefinitionId = this.rowData.processDefinitionId
            params.processInstanceId = this.rowData.processInstanceId
            params.variables =
              this.getComponentByOption === 'CVEditPage'
                ? newMap
                : this.rowData.variables

            delete params.isPass
            todoAPi
              .completeTask(params)
              .then((res) => {
                this.modalShow = false
                this.auditLoading = false
                this.confirmModalShow = false
                this.onLoad(this.page)
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: this.$t('_default.toast.title'),
                    icon: 'BellIcon',
                    text: this.$t('_default.toast.text.success'),
                    variant: 'success',
                  },
                })
              })
              .catch(() => {
                this.auditLoading = false
              })
          }
        }
      })
    },
    findData(key) {
      let res = {}
      if (this.processInstanceId) {
        res =
          this.data.find(
            (o) => o.processInstanceId === this.processInstanceId,
          ) || {}
      } else {
        res = this.data.find((o) => o.id === this.rowData.id) || {}
      }
      return res[key]
    },
  },
}
</script>

<style lang="scss" scoped>
.myApplication-list {
  position: relative;
}
</style>
